// Frittstående logistikk-panel (poppet ut). Egen WS-feed; LOGSTAT + forsynings-
// anmodninger flyter via hubbens collab-fanout (org-scope) og flettes monotont.
import {
  parseLogStatOne, mergeLogStat, type LogStat,
  parseResupplyOne, mergeResupply, type ResupplyRequest,
} from '@skade/contracts';
import type { User } from '@skade/rbac';
import type { Feed } from '../data/feed.js';
import type { SyncBus } from '../sync.js';
import { LogisticsPanel } from '../ui/logistics.js';
import { byggKontekst } from '../kontekst.js';

export function mountLogisticsPanel(root: HTMLElement, feed: Feed, _sync: SyncBus, user: User): void {
  document.body.classList.add('panel-standalone');
  root.innerHTML = '';
  const logstats = new Map<string, LogStat>();
  const resupplies = new Map<string, ResupplyRequest>();
  const myUnit = user.org?.troop || user.org?.area || user.org?.district || user.id;
  const upLog = (l: LogStat) => { const e = logstats.get(l.id); logstats.set(l.id, e ? mergeLogStat(e, l) : l); };
  const upRes = (r: ResupplyRequest) => { const e = resupplies.get(r.id); resupplies.set(r.id, e ? mergeResupply(e, r) : r); };
  const panel = new LogisticsPanel({
    self: user.id, myUnit,
    getLogStats: () => [...logstats.values()],
    getResupply: () => [...resupplies.values()],
    publishLogStat: (l) => { upLog(l); feed.send?.({ type: 'logstat', logstat: l }); },
    publishResupply: (r) => { upRes(r); feed.send?.({ type: 'resupply', resupply: r }); },
    // Eget vindu = ingen kart → posisjonen er ærlig ukjent (se casualty-panel.ts).
    kontekst: () => byggKontekst({ bruker: user, posisjon: null, naaMs: Date.now() }),
    naa: () => Date.now(),
    // Delta-rapportering virker også her: forrige LOGSTAT for egen enhet kommer
    // fra hub-replay inn i samme kart som lista viser.
    forrigeLogStat: () => logstats.get(`log-${myUnit}`) ?? null,
  });
  panel.el.classList.add('open', 'embedded');
  root.append(panel.el);
  feed.onCollab?.((m) => {
    if (m.kind === 'logstat' && m.logstat) { const l = parseLogStatOne(m.logstat); if (l) { upLog(l); panel.render(); } }
    else if (m.kind === 'resupply' && m.resupply) { const r = parseResupplyOne(m.resupply); if (r) { upRes(r); panel.render(); } }
  });
  feed.start();
}
